import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

import { AuthServices } from "../services/AuthServices";
import { IoKey } from "react-icons/io5";
import useUpdateOnboardingStatus from "../../../utils/hooks/useUpdateOnboardingStatus";

const Password = ({ setStep }) => {
  const [formData, setFormData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const updateOnboardingStatus = useUpdateOnboardingStatus();

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})/;

    if (!passwordRegex.test(formData.password)) {
      setErrorMessage(
        "Password must be at least 8 characters long, include one special character, and one capital letter.",
      );
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    if (formData.password !== formData.verifyPassword) {
      setErrorMessage("Passwords do not match");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    try {
      const p = formData.password;
      const response = await AuthServices.createSecurePassword(p);
      if (!response.success) {
        setErrorMessage(
          "Error updating password your password. If the problem persists please contact support.",
        );
        return;
      }

      const statusUpdate = await updateOnboardingStatus("password");
      if (!statusUpdate) {
        setErrorMessage(
          "Error updating password your password. If the problem persists please contact support.",
        );
        return;
      }

      setStep(2);
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message ||
          setErrorMessage(
            "Error updating password your password. If the problem persists please contact support.",
          ),
      );
      console.error("There was an error while creating your account:", error);
    }
  };

  return (
    <div className="address-container">
      <form onSubmit={handleSubmit}>
        <IoKey className="address-icon" />
        <h2>Choose your password</h2>
        <p>
          Password must be at least 8 characters long, include one special
          character, and one capital letter.
        </p>
        <div className="password-container">
          <input
            autoComplete="new-password"
            onChange={handleChange}
            type="password"
            name="password"
            placeholder="Choose a password"
          />
          <input
            autoComplete="new-password"
            onChange={handleChange}
            type="password"
            name="verifyPassword"
            placeholder="Confirm password"
          />
        </div>
        <button>Continue</button>
      </form>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
};

export default Password;
